import { all, call, put, takeLatest } from 'redux-saga/effects';

import { homeAPIs } from 'apis/services';
import { searchAPIs } from 'apis/services/search';
import { ActionTypeEnum } from 'redux/ActionTypeEnum';
import { loadingAction } from 'redux/settings/action';

import { homeCategoryActionSuccess, searchCategoryActionSuccess } from './action';

// getting home categories
function* categoriesRequest({ payload, meta }) {
	try {
		yield put(loadingAction({ skeleton: true }));
		const response = yield call(homeAPIs.categories, payload);
		yield put(homeCategoryActionSuccess(response.data?.Content));
		yield put(loadingAction({ skeleton: false }));
	} catch (error) {
		yield put({ type: ActionTypeEnum.error, payload: error, meta });
	}
}

// getting search category
function* searchCategoryRequest({ payload, meta }) {
	try {
		yield put(loadingAction({ skeleton: true }));
		const response = yield call(searchAPIs.categories, payload);
		yield put(searchCategoryActionSuccess(response.data?.Content));
		yield put(loadingAction({ skeleton: false }));
	} catch (error) {
		yield put({ type: ActionTypeEnum.error, payload: error, meta });
	}
}
export default function* categorySaga() {
	yield all([
		takeLatest(ActionTypeEnum.search_categories_request, searchCategoryRequest),
		takeLatest(ActionTypeEnum.home_categories_request, categoriesRequest),
	]);
}
